/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unreachable */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, FormFeedback, Input, Label, Row } from 'reactstrap';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import myProfile from '../../assets/images/commons/myProfile.svg';
import changePassword from '../../assets/images/commons/changePassword.svg';
import changeRole from '../../assets/images/commons/changeRole.svg';
import logout from '../../assets/images/commons/logout.svg';
import * as Yup from 'yup';
import { FastField, useFormik } from 'formik';
import OffcanvasModal from './OffcanvasModal';
import withRouter from './withRouter';
import * as url from '../../../src/helpers/url_helper';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { loginSuccess, logoutUserSuccess } from 'slices/auth/login/reducer';
import { resetUserSelecteRole } from 'slices/thunks';
import { store } from 'slices/persister';
import InputComponent from 'Components/DynamicComponents/InputComponent';
import SelectComponent from 'Components/DynamicComponents/SelectComponent';
import InputGroupComponent from 'Components/DynamicComponents/InputGroupComponent';
import DropzoneComponent from 'Components/DynamicComponents/DropzoneComponent';
import toastMessages from './messages/toastMessages';
import { AuthUser, displayFirstLastName, generateInitialValues, generateValidationSchema, getDate, trimValues } from './Util';
import CommonModal from './CommonModal';
import { PROFILE_SCHEMA, PROFILE_SCHEMA_EDIT } from './FormSchemas/FormSchema';
import captian from '../../../src/assets/images/commons/captain.jpeg';
import profile from '../../../src/assets/images/commons/profile.svg';

import TruncatedCopyText from './Tooltip/TruncatedCopyText';

const POST_LOGOUT_REDIRECT = process.env.REACT_APP_SHOW_HOME_PAGE === 'true' ? '/home' : '/login';

const ProfileDropdown = (props: any) => {
    const profiledropdownData = createSelector(
        (state: any) => state?.Profile,
        (user) => user?.user
    );
    // Inside your component
    const userDetails = AuthUser();
    const [showProfile, setShowProfile] = useState<boolean>(false);
    const [modalLoader, setModalLoader] = useState<boolean>(false);
    const [profileSchema, setProfileSchema] = useState<any>(PROFILE_SCHEMA);
    // const [profileSchemaEdit,setProfileSchemaEdit] = useState<any>(PROFILE_SCHEMA_EDIT)
    const [profileEditButton, setProfileEditButton] = useState<boolean>(false);
    const [selectedOption, setSelectedOption] = useState<any>();
    const [lastLogin, setLastLogin] = useState<any>('loading');
    const profileUrl = process.env.REACT_APP_API_URL + url.VIEW_DOCUMENTS + '/';
    const selectedRole = useSelector((state: any) => state.SelectedRole?.role?.value);
    useEffect(() => {
        let username = userDetails?.userProfile?.roles?.[0]?.role?.replace(/_/g, ' ');
        if (userDetails?.userProfile?.roles?.length > 1) {
            username = selectedRole?.replace(/_/g, ' ');
        }
        setUserName(username);
    }, [selectedRole, userDetails]);

    const [userName, setUserName] = useState('Admin');
    // const date = new Date(userDetails?.lastLogin).toLocaleString('en-US', {
    //     month: 'long',
    //     day: 'numeric',
    //     year: 'numeric',
    //     hour: '2-digit',
    //     minute: '2-digit',
    //     hour12: true
    // });
    useEffect(() => {
        const lastLogin = getDate(userDetails.lastLogin);
        setLastLogin(lastLogin);
    }, []);
    useEffect(() => {
        const authUSer: any = sessionStorage.getItem('authUser');
        if (authUSer) {
            const obj: any = JSON.parse(authUSer);
        }
    }, [userName]);

    // Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const [changePassModal, setChangePassModal] = useState<boolean>(false);
    const [oldPasswordShow, oldSetPasswordShow] = useState<boolean>(false);
    const [passwordShow, setPasswordShow] = useState<boolean>(false);
    const [confirmPasswordShow, confirmSetPasswordShow] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [imgError, setImgError] = useState<boolean>(false);
    const dispatch: any = useDispatch();
    const api = props?.router?.apiClient;
    const authUser = props?.router?.user ?? {}; // Default to an empty object

    const hasMultipleRole = authUser?.userProfile?.roles?.length > 1;

    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            currentPassword: '',
            newPassword: '',
            confirm_reset_password: ''
        },
        validationSchema: Yup.object({
            currentPassword: Yup.string().required('Please Enter Your Current Password'),
            // newPassword: Yup.string()
            //     .required('Please Enter Your New Password')
            //     .matches(
            //         /^(?!.*[\s])(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
            //         'The password should be minimum 8 digits with mixture of atleast 1 uppercase, 1 lowercase, 1 number and 1 special character & without spaces.'
            //     ),
            newPassword: Yup.string()
                .required('Please Enter Your New Password')
                .matches(
                    /^(?!.*\s)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,16}$/,
                    'The password must contain at least one uppercase letter, one number, one special character, no spaces and be between 8 to 16 characters long'
                ),

            confirm_reset_password: Yup.string()
                .required('Please Confirm Your New Password')
                .oneOf([Yup.ref('newPassword'), 'null'], 'Passwords must match')
        }),
        onSubmit: () => {
            //
        }
    });

    const closeChangePass = () => {
        setChangePassModal(false);
        validation.resetForm();
    };

    const handleChangePasswordModal = () => {
        return (
            <Row>
                <div className="h-100">
                    <form autoComplete="off" className="mx-3 mb-lg-0 d-flex flex-column">
                        <div className="mb-2 my-1">
                            <Label htmlFor="current_password" className="form-label fs-14">
                                Current Password
                                <b className="text-danger ms-2">*</b>
                            </Label>
                            <div className="position-relative">
                                <Input
                                    name="currentPassword"
                                    className="form-control"
                                    placeholder="Enter Current Password"
                                    type={oldPasswordShow ? 'text' : 'password'}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.currentPassword || ''}
                                    invalid={validation.touched.currentPassword && validation.errors.currentPassword ? true : false}
                                    autoComplete="off"
                                    onFocus={(e) => {
                                        e.target.setAttribute('readonly', 'true');
                                        setTimeout(() => e.target.removeAttribute('readonly'), 100);
                                    }}
                                    maxLength={16}
                                />
                                {validation.touched.currentPassword && validation.errors.currentPassword ? (
                                    <FormFeedback type="invalid">{validation.errors.currentPassword}</FormFeedback>
                                ) : null}
                                {validation.values.currentPassword && validation.values.currentPassword !== '' && (
                                    <button
                                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted zindex99"
                                        type="button"
                                        id="password-addon"
                                        onClick={() => oldSetPasswordShow(!oldPasswordShow)}
                                    >
                                        <i className="ri-eye-fill align-middle "></i>
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="mb-2 my-1">
                            <Label className="form-label fs-14" htmlFor="password-input">
                                New Password
                                <b className="text-danger ms-2">*</b>
                            </Label>
                            <div className="position-relative">
                                <Input
                                    name="newPassword"
                                    autoComplete="off"
                                    onFocus={(e) => {
                                        e.target.setAttribute('readonly', 'true');
                                        setTimeout(() => e.target.removeAttribute('readonly'), 100);
                                    }}
                                    value={validation.values.newPassword || ''}
                                    type={passwordShow ? 'text' : 'password'}
                                    className="form-control"
                                    placeholder="Enter New Password"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.newPassword && validation.errors.newPassword ? true : false}
                                    maxLength={16}
                                />
                                {validation.touched.newPassword && validation.errors.newPassword ? (
                                    <FormFeedback type="invalid">{validation.errors.newPassword}</FormFeedback>
                                ) : null}
                                {validation.values.newPassword && validation.values.newPassword !== '' && (
                                    <button
                                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted zindex99"
                                        type="button"
                                        id="password-addon"
                                        onClick={() => setPasswordShow(!passwordShow)}
                                    >
                                        <i className="ri-eye-fill align-middle "></i>
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="mb-2 my-1">
                            <Label className="form-label fs-14" htmlFor="password-input">
                                Confirm New Password
                                <b className="text-danger ms-2">*</b>
                            </Label>
                            <div className="position-relative">
                                <Input
                                    autoComplete="off"
                                    onFocus={(e) => {
                                        e.target.setAttribute('readonly', 'true');
                                        setTimeout(() => e.target.removeAttribute('readonly'), 100);
                                    }}
                                    name="confirm_reset_password"
                                    value={validation.values.confirm_reset_password || ''}
                                    type={confirmPasswordShow ? 'text' : 'password'}
                                    className="form-control"
                                    placeholder="Re Enter New Password"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.confirm_reset_password && validation.errors.confirm_reset_password ? true : false
                                    }
                                    maxLength={16}
                                />
                                {validation.touched.confirm_reset_password && validation.errors.confirm_reset_password ? (
                                    <FormFeedback type="invalid">{validation.errors.confirm_reset_password}</FormFeedback>
                                ) : null}
                                {validation.values.confirm_reset_password && validation.values.confirm_reset_password !== '' && (
                                    <button
                                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted zindex99"
                                        type="button"
                                        id="password-addon"
                                        onClick={() => confirmSetPasswordShow(!confirmPasswordShow)}
                                    >
                                        <i className="ri-eye-fill align-middle"></i>
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </Row>
        );
    };

    const saveChangePassword = () => {
        const params = {
            newPassword: validation?.values?.confirm_reset_password,
            oldPassword: validation?.values?.currentPassword
        };

        api.get(url.USER_UPDATE_PASSWORD, { headers: params }).then((res: any) => {
            if (res?.status?.toLowerCase() === 'success') {
                toast.success('Password changed sucessfully');
                setChangePassModal(false);
                validation?.resetForm();
                localStorage?.clear();
                sessionStorage?.clear();
                dispatch(logoutUserSuccess(true));
                props?.router?.navigate(POST_LOGOUT_REDIRECT);
            } else {
                validation.resetForm();
            }
        });
    };

    const onCheckValidation = () => {
        if (validation.isValid && validation.dirty && validation.values.newPassword === validation.values.confirm_reset_password) {
            saveChangePassword();
        } else {
            validation?.handleSubmit();
        }
    };
    const showProfileTrigger = () => {
        setShowProfile(!showProfile);
    };
    const viewProfileBoady = () => {
        return (
            <React.Fragment>
                <Row>
                    {profileSchema?.length > 0 &&
                        profileSchema.map((field: any, index: number) => {
                            return (
                                <React.Fragment key={index}>
                                    {field.isVisible && <Col lg={field?.lg1}>{renderItems({ ...field }, EditUserValidation)}</Col>}
                                </React.Fragment>
                            );
                        })}
                </Row>
            </React.Fragment>
        );
    };
    const generateFetchValues = (formData: any[], rowData: any) => {
        const initialValues: any = {};
        formData?.forEach((field) => {
            if (field.inputType === 'upload') {
                // initialValues[field?.value] = rowData?.[field?.value] || '';
                initialValues[field?.value] = [
                    {
                        // preview: 'ProfileImage/1747928127647081997.jpeg'

                        preview: rowData?.[field.value]
                        // name: rowData?.[field.value],
                        // formattedSize: '22KB',
                        // fileID: rowData?.[field.value],
                        // fileName: rowData?.[field.value]
                    }
                ];
            } else if (field.inputType === 'centerItems') {
                if (field.inputDateType === 'Array') {
                    initialValues[field?.value] = rowData?.userProfile?.roles?.[0]?.role;
                } else {
                    initialValues[field?.value] = rowData?.[field?.value] || '';
                }
            } else if (field.inputType === 'displayItems') {
                if (field.inputDateType === 'Array') {
                    initialValues[field?.value] = rowData?.[field?.value];
                } else {
                    initialValues[field?.value] = rowData?.[field?.value] || '';
                }
            } else if (field.inputType === 'inputgroup') {
                initialValues[field?.value] = rowData?.[field?.value]?.value;
            } else if (field.inputType === 'input') {
                initialValues[field?.value] = rowData?.[field?.value] || '';
            }
        });
        return initialValues;
    };
    const EditUserValidation: any = useFormik({
        enableReinitialize: true,
        initialValues: generateFetchValues(profileSchema, {
            ...userDetails,
            fullName: userDetails?.firstName + ' ' + userDetails?.lastName
        }),
        validationSchema: generateValidationSchema(profileSchema, Yup),
        validate: (values) => trimValues(values, profileSchema),
        onSubmit: (values) => {
            // delete the profile picture from DB
            if (userDetails?.profileImage === values?.profileImage?.[0]?.preview) {
            } else {
                setLoading(true);
                api.deleteFile(`${url.DELETE_DOCUMENTS}/${userDetails?.profileImage}`)
                    .then((resp: any) => {
                        if (resp?.status?.toLowerCase() === 'success') {
                            setLoading(false);
                            // toast.success(resp?.data?.message);
                        } else {
                            setLoading(false);
                        }
                    })
                    .catch((e: any) => {
                        // toast.error(toastMessages.errorInDeletion);
                        setLoading(false);
                        // setShowProfile(!showProfile);
                        // setProfileEditButton(false);
                        // setProfileSchema(PROFILE_SCHEMA);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }

            let body = {
                phoneNumber: {
                    code: '+91',
                    value: values?.phoneNumber
                },
                address: values?.address,
                profileImage: values?.profileImage
            };
            setShowProfile(!showProfile);
            setProfileEditButton(false);
            setProfileSchema(PROFILE_SCHEMA);

            const clonedUserDetails = JSON.parse(JSON.stringify(userDetails));
            const updatedUserDetails = {
                ...clonedUserDetails,
                phoneNumber: body.phoneNumber,
                profileImage: body.profileImage?.[0]?.preview || '',
                address: body.address
            };
            dispatch(loginSuccess(updatedUserDetails));
            const payload: any = JSON.parse(JSON.stringify(updatedUserDetails));

            const keysToRemove = [
                'password',
                'token',
                'createdAt',
                'updatedAt',
                'isFirstLogin',
                'approvedAt',
                'lastLogin',
                'createdBy',
                'lastActivity'
            ];

            keysToRemove.forEach((key) => delete payload[key]);

            // return
            setLoading(true);
            api.create(url?.CREATE_USER, payload)
                .then((res: any) => {
                    if (res?.status?.toLowerCase() === 'success') {
                        EditUserValidation?.resetForm();
                        // toast.success(toastMessages?.userAdded);
                        toast.success(res?.data?.message);
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                })
                .catch((err: any) => setLoading(false));
        }
    });
    const handleValidationPatternChange = (option: any) => {
        setSelectedOption(option?.validationPattern); // Update the selected option when the dropdown value changes
    };
    const renderItems = (field: any, validation: any): JSX.Element | any => {
        switch (field.inputType) {
            case 'upload':
                return (
                    <>
                        {' '}
                        <Col lg={12}>
                            <div className="my-0">
                                {uploadComponent(field, validation)}
                                {/* <img src={'https://ddfarmerdev.s3.ap-south-1.amazonaws.com/Nova%20Logo%203.png'}/> */}
                            </div>
                        </Col>
                    </>
                );
            case 'centerItems':
                return (
                    <>
                        <div className={`d-flex justify-content-center font-weight-500 font-size-16 mb-3`}>
                            <span className={`${field.inputDateType === 'Array' ? 'font-size-16 role-badge' : 'font-weight-400'}`}>
                                {' '}
                                {validation?.values?.[field?.value]}
                            </span>
                        </div>
                    </>
                );
            case 'displayItems':
                return (
                    <>
                        <div
                            className="d-grid"
                            style={{
                                display: 'grid',
                                gridTemplateColumns: '50% 50%',
                                width: '100%',
                                marginBottom: '10px'
                            }}
                        >
                            <div style={{ paddingLeft: '5%' }}>
                                <label className="bg-grey-2">{field?.label}</label>
                            </div>
                            <div>
                                <span className="font-size-16 font-weight-400" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                    {typeof validation?.values?.[field?.value] === 'object'
                                        ? `${validation?.values?.[field?.value]?.code || ''} ${
                                              validation?.values?.[field?.value]?.value || ''
                                          }`
                                        : validation?.values?.[field?.value]}
                                </span>
                            </div>
                        </div>
                    </>
                );
            case 'input':
                return (
                    <div className={'my-3 px-3'}>
                        <InputComponent field={field} mode={''} validation={EditUserValidation}></InputComponent>
                    </div>
                );
            case 'dropdown':
                return (
                    <div className={'my-3 px-3'}>
                        <SelectComponent
                            field={field}
                            mode={'add'}
                            validation={EditUserValidation}
                            // onChange={(e) => handleChange(e, field)}
                        ></SelectComponent>
                    </div>
                );
            case 'inputgroup':
                return (
                    <div className={'my-3 px-3'}>
                        <InputGroupComponent
                            field={field}
                            validation={EditUserValidation}
                            mode={''}
                            // eslint-disable-next-line multiline-comment-style
                            schemaRegex={EditUserValidation.values.phoneExtension?.validationPattern || ''}
                            handlepattern={handleValidationPatternChange}
                        ></InputGroupComponent>
                    </div>
                );
        }
    };

    const fetchPic = (file: any) => {
        const filepath = file;
        setLoading(true);
        api.deleteFile(`${url.VIEW_DOCUMENTS}/${filepath}`)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success') {
                    setLoading(false);
                    toast.success(resp?.data?.message);
                } else {
                    setLoading(false);
                }
            })
            .catch((e: any) => setLoading(false))
            .finally(() => {
                setLoading(false);
            });
    };
    const uploadComponent = (field: any, formValidation: any) => {
        return (
            <div className="d-flex justify-content-center">
                <div>
                    {/* <label htmlFor={field.label}>{field.label}</label>{' '} */}
                    {/* <span className="text-danger ps-1"> {field.mandatory ? '*' : ''}</span> */}
                    <DropzoneComponent
                        noOfFilesAccepted={field.noOfFiles || 1}
                        maxSize={field.fileSize || 5 * 1024 * 1024}
                        fieldName={field.value}
                        type={field.type}
                        accept={field.accept}
                        // accept={field.accept || 'application/vnd.openxmlformats-officedocument.spreadsheetml'}
                        files={formValidation.values[field.value] ? formValidation.values[field.value] : []}
                        handleOnChange={(event: any) => {
                            handleChangeFiles({
                                name: field.value,
                                value: event.target.files,
                                id: field.value,
                                action: event.target.action,
                                file: event.target.file
                            });
                            formValidation.handleChange({
                                target: {
                                    name: field.value,
                                    value: event.target.files,
                                    id: field.value
                                }
                            });
                        }}
                        onBlur={formValidation.handleBlur}
                        field={field}
                        values={{ uploadType: formValidation.values?.['type'] || '' }}
                        showHeader={false}
                        label={field.label}
                        isMultipleFiles={field.isMultifiles || false}
                        fileTypeMsg={field?.fileTypeMsg}
                        required={field.required || false}
                        disabled={field.isDisabled || false}
                        dropzoneheight={'20'}
                        handleDeleteFile={handleDeleteFile}
                        profile={true}
                        profileEditButton={profileEditButton}
                    ></DropzoneComponent>
                    {formValidation.touched[field.value] && formValidation.errors[field.value] ? (
                        <p className="text-danger fs-12 pt-1">'is required'</p>
                    ) : null}
                </div>
            </div>
        );
    };
    const handleChangeFiles = (obj: any) => {
        if (obj.action !== 'DELETE') {
            const formData = new FormData();
            formData.append('file', obj.value[obj.value?.length - 1]);
            formData.append('folder', 'ProfileImage');

            const file = obj.value[0];
            setLoading(true);
            api.uploadFile(url.UPLOAD_DOCUMENTS, formData)
                .then((res: any) => {
                    if (res.status?.toLowerCase() === 'success') {
                        toast.success(res?.data?.message);

                        const fileData = res?.data;
                        const fileName = fileData?.filePath;
                        const fileArray = fileName?.split('/');
                        const fileID = fileArray?.[fileArray?.length - 1];
                        // const preview = url.UPLOAD_PRIEVIEW(fileID);
                        const preview = fileName;
                        // setProfileUrl([{ preview, name: fileName, formattedSize: file?.formattedSize, fileID, fileName }]);

                        EditUserValidation.setFieldValue('profileImage', [
                            { preview, name: fileName, formattedSize: file?.formattedSize, fileID, fileName }
                        ]);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        toast.error('no matching header row found');
                    }
                })
                .catch((err: any) => {
                    setLoading(false);
                    toast.error(err?.message);
                });
        }
    };
    const handleDeleteFile = (fieldName: any, file: any, index?: number) => {
        if (file) {
            if (userDetails?.profileImage === file?.preview) {
            } else {
                const filepath = file.preview;

                setLoading(true);
                api.deleteFile(`${url.DELETE_DOCUMENTS}/${filepath}`)
                    .then((resp: any) => {
                        if (resp?.status?.toLowerCase() === 'success') {
                            setLoading(false);
                            // toast.success(resp?.data?.message);
                        } else {
                            setLoading(false);
                        }
                    })
                    .catch((e: any) => {
                        // toast.error(toastMessages.errorInDeletion);

                        setLoading(false);
                        // setShowProfile(!showProfile);
                        // setProfileEditButton(false);
                        // setProfileSchema(PROFILE_SCHEMA);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        }
    };
    const handleProfileEdit = () => {
        // dispatch(loginSuccess('response.data'));
        setProfileEditButton(!profileEditButton);
        setProfileSchema(PROFILE_SCHEMA_EDIT);
    };
    const handleProfileClose = () => {
        profileEditButton && handleDeleteFile(undefined, EditUserValidation?.values?.profileImage?.[0]);
        setShowProfile(!showProfile);
        setProfileEditButton(false);
        setProfileSchema(PROFILE_SCHEMA);
    };
    const onLogout = () => {
        const payLoad = {};
        setLoading(true);
        api.get(url?.LOGOUT_USER, payLoad, false, false)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success' && resp?.data) {
                    setLoading(false);
                    props?.router?.navigate('/logout');
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const renderTruncatedLabel = (label: string, text: string, className = 'd-none d-xl-inline-block ms-1 fw-medium user-name-text') => {
        if (!text?.trim()) return null;

        return (
            <span className={className}>
                {label}: <TruncatedCopyText text={text?.trim()} maxLength={16} textColor="text-white" hoverTextClassname="p-1" />
            </span>
        );
    };

    return (
        <React.Fragment>
            <Dropdown
                isOpen={isProfileDropdown}
                toggle={toggleProfileDropdown}
                className="ms-sm-3 header-item topbar-user"
                style={{ backgroundColor: '#383838' }}
            >
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        {userDetails?.profileImage && !imgError ? (
                            <>
                                <img
                                    className="rounded-circle header-profile-user"
                                    src={profileUrl + userDetails?.profileImage}
                                    alt="Header Avatar"
                                    onError={() => setImgError(true)}
                                />
                            </>
                        ) : (
                            <span className="text-white bg-primary rounded-circle d-inline-flex justify-content-center align-items-center width-38-px height-38-px font-size-16 font-weight-600 border border-white">
                                {displayFirstLastName()}
                            </span>
                        )}

                        <span className="text-start ms-xl-2">
                            {renderTruncatedLabel('Name', `${userDetails?.firstName ?? ''} ${userDetails?.lastName ?? ''}`)}

                            {selectedRole && renderTruncatedLabel('Role', userName, 'd-none d-xl-block ms-1 fw-medium user-name-text')}
                        </span>
                        {/* <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{lastLogin}</span> */}
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    {/* <h6 className="dropdown-header">Welcome {userName}!</h6> */}

                    <DropdownItem onClick={showProfileTrigger}>
                        <img src={profile} alt="my-profile" className="fs-16 align-middle me-1" />

                        <span className="align-middle">My Profile</span>
                    </DropdownItem>

                    {/* <DropdownItem className="p-0">
            <Link to="/apps-chat" className="dropdown-item text-secondary">
              <img src={changePassword} alt='my-profile' className="fs-16 align-middle me-1"/>
              <span className="align-middle">Change Password</span>
            </Link>
          </DropdownItem> */}

                    <DropdownItem onClick={() => setChangePassModal(true)}>
                        <i className="ri-lock-2-line text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Change Password</span>
                    </DropdownItem>
                    {hasMultipleRole && (
                        <DropdownItem
                            className="p-0"
                            onClick={() => {
                                dispatch(resetUserSelecteRole());
                                props?.router?.navigate('/choose-role');
                            }}
                        >
                            <Link to={''} className="dropdown-item text-secondary">
                                {/* <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i>{' '} */}
                                <img src={changeRole} alt="my-profile" className="fs-16 align-middle me-1" />
                                <span className="align-middle">Change Role</span>
                            </Link>
                        </DropdownItem>
                    )}

                    {/* <DropdownItem className="p-0">
            <Link to="/pages-faqs" className="dropdown-item">
              <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Help</span>
            </Link>
          </DropdownItem> */}
                    {/* <DropdownItem className="p-0">
            <Link to="/pages-profile" className="dropdown-item">
              <i className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">
                Balance : <b>$5971.67</b>
              </span>
            </Link>
          </DropdownItem> */}
                    {/* <DropdownItem className="p-0">
            <Link to="/pages-profile-settings" className="dropdown-item">
              <span className="badge bg-success-subtle text-success mt-1 float-end">
                New
              </span>
              <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Settings</span>
            </Link>
          </DropdownItem> */}
                    {/* <DropdownItem className="p-0">
            <Link to="/auth-lockscreen-basic" className="dropdown-item">
              <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Lock screen</span>
            </Link>
          </DropdownItem> */}
                    <DropdownItem className="p-0">
                        <div className="dropdown-item text-secondary" onClick={onLogout}>
                            {/* <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{' '} */}
                            <img src={logout} alt="my-profile" className="fs-16 align-middle me-1" />
                            <span className="align-middle" data-key="t-logout">
                                Logout
                            </span>
                        </div>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
            {changePassModal && (
                <OffcanvasModal
                    direction="end"
                    toggle={() => closeChangePass()}
                    open={changePassModal}
                    handleCloseClick={() => closeChangePass()}
                    OffcanvasModalID="changepassword"
                    handleOffcanvasBody={handleChangePasswordModal}
                    modalClassName="w-35"
                    saveText={'Save'}
                    offcanvasHeader={'Change Password'}
                    loading={false}
                    headerBgColor={true}
                    handleSaveClick={onCheckValidation}
                    saveDisabled={!validation?.isValid || loading || !validation.dirty}
                />
            )}
            <CommonModal
                size={'md'}
                isHeader={true}
                show={showProfile}
                handleModalBody={viewProfileBoady}
                onCloseClick={() => {
                    handleProfileClose();
                }}
                disabled={modalLoader}
                headerClass={''}
                modalheader={'Profile Information'}
                hideSaveButton={true}
                hideCancelButton={true}
                backgroundColor={true}
                headerColor={'black'}
                profileButtons={true}
                profileEditButton={profileEditButton}
                handleProfileEdit={handleProfileEdit}
                validation={EditUserValidation}
                // profileUpdateButton={true}
                // cancelText={'Cancel'}
                // saveText={mode === 'add' || mode === '' ? 'Save' : 'Update'}
                handleClick={EditUserValidation.handleSubmit}
            />
        </React.Fragment>
    );
};

export default withRouter(ProfileDropdown);
